/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeSMinusIcon16Regular = forwardRef('MediaAudioVolumeSMinusIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 2.332a.9.9 0 0 0-1.495-.674L3.716 5H1.5A1.5 1.5 0 0 0 0 6.5v3A1.5 1.5 0 0 0 1.5 11h2.216l3.789 3.342A.9.9 0 0 0 9 13.668V2.332ZM4.638 6.187 7.5 3.662v8.676L4.638 9.813a1.25 1.25 0 0 0-.827-.313H1.5v-3h2.311c.305 0 .599-.111.827-.313Z" }),
        React.createElement("path", { d: "M11 7.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-4Z" })));
});
